export var IdAssetBundleDoghouse;
(function (IdAssetBundleDoghouse) {
    IdAssetBundleDoghouse["Doghouse_1"] = "Doghouse_1";
})(IdAssetBundleDoghouse || (IdAssetBundleDoghouse = {}));



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/outskirts/IdAssetBundleDoghouse.ts
// module id = 733
// module chunks = 3